/* eslint-disable */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import reportsSlice from '../reducer/reportsSlice';
import pdfSlice from '../reducer/pdfSlice';
import blobsSlice from '../reducer/blobsSlice';

export const store = configureStore({
  reducer: {
    [blobsSlice.namespace]: blobsSlice.reducer,
    [pdfSlice.namespace]: pdfSlice.reducer,
    [reportsSlice.namespace]: reportsSlice.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
